import React from 'react';
import { Box, styled } from '@mui/material';
import { Header } from '../Header';

export type AnoynmousLayoutProps = {
}

const ui = {
    Layout: styled(Box)(({ theme }) => ({})),
};

export const AnoynmousLayout: React.FC<React.PropsWithChildren<AnoynmousLayoutProps>> = (props) => {
    const { children } = props;
    return (
        <ui.Layout>
              {children}
        </ui.Layout>
    );
}